import successfulRegistrationGif from '../../assets/Registration successful.gif';
import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react'
import './Styles.css';

const SuccessfulRegistration = () => {
   const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate('/casuals/all'); // Replace '/another-page' with the path to your desired page
    }, 3000); // 3 seconds delay

    return () => clearTimeout(timeout);
  }, [navigate]);
  return (
    <div className='loginbottom'>
    <center>
    <div>
      <h2>Registration Successful!</h2>
      <img src={successfulRegistrationGif} alt="Registration successful" />
    </div>
    </center>
    </div>
  );
}

export default SuccessfulRegistration;
